<template>
  <div class="app" style="width: 100%;">
    <img :src="tupian" @click="go" class="xiaoshou" style="width:100%;height:auto;" />
    <el-row justify="center" type="flex">
      <el-col :span="22">
        <div class="flex" id="navs" style="border-bottom:2px solid #1CB278;padding:2px 0;">
          <div class="img1">
            <img src="../assets/img/he1.1.png" style="width:100px;height: 70px;" />
          </div>
          <div class="flex align-center" id="nav">
            <div @click="dianwole" style="min-width: 56px;height: 100%;">
              <router-link to="/">首页</router-link>
            </div>
            <router-link to="/schment">校招攻略</router-link>
            <router-link to="/member">vip会员</router-link>
            <router-link to="/dynamics">行业动态</router-link>
            <router-link to="/cooperat">企业合作</router-link>
            <router-link to="/about">关于我们</router-link>
            <div class="login backbg" style="max-height: 20px;width: 62px;" v-if="!islogin">
              <div @click="login()" class="xiaoshou" style="border-right: 1px solid #FFFFFF;">登录</div>
              <div @click="register()" class="xiaoshou">注册</div>
            </div>
            <div class="login flex align-center color" style="max-height: 20px;background: #FFFFFF;" v-if="islogin">
              <div @click="userInfo()" class="xiaoshou" style="border-right: 1px solid #000000;color:#42b983">{{name}}</div>
              <div @click="signout()" class="xiaoshou" style="color: #000000;">退出</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
      tupian: '',
      href: ''
    }
  },
  components: {},
  computed: {
    name() {
      return this.$store.state.username
    },
    islogin() {
      return this.$store.state.islogin
    }
  },
  mounted() {
    // if (window.localStorage.getItem('id') != '') {
    // 	this.$store.state.islogin = true
    // }
    this.$axios.get('/api/ad/detail?slug=index_top').then(res => {
      this.tupian = 'http://api.xiaozhaozhushou.net/storage/' + res.data.data.img
      this.href = res.data.data.url
    })
  },
  methods: {
    dianwole() {
      if (this.$parent.$parent.$parent.type) {
        this.$parent.$parent.$parent.type = 0
      }
    },
    changeActive($event) {
      $event.currentTarget.className = 'hover'
    },
    removeActive($event) {
      $event.currentTarget.className = ''
    },
    go() {
      window.open(this.href)
    },
    login() {
      this.$router.push('/login')
    },
    register() {
      this.$router.push('/register')
    },
    signout() {
      this.$store.commit('ISLOGIN', false)
      window.localStorage.clear()
    },
    userInfo() {
      this.$router.push('/userInfo')
    }
  }
}
</script>
<style scoped lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

#navs {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#nav {
  a {
    font-size: 12px;
    color: #2c3e50;
    padding: 4px 0px;
    margin: 0 15px;
    min-width: 48px;
    font-weight: 400 !important;

    &.router-link-exact-active {
      color: #42b983;
      border-bottom: 2px solid #42b983;
    }
  }
  a:hover {
    color: #42b983;
  }
}

.login {
  display: flex;
  font-size: 10px;
  margin-left: 10px;
  color: #ffffff;
  border-radius: 5px;
  padding: 5px;
}

.login > div {
  margin: 2px;
}

.login > div:first-child {
  margin: 2px;
  padding-right: 4px;
}
</style>
